module.exports = __webpack_public_path__ + "assets/Openbite.9aa16e4cd45354062ec570755ab30bdc.svg";